import styles from "./Home.module.scss";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface Trainer {
	name: string;
	subName: string;
	position: string;
	thumbImage: string;
	subImage: string;
	comment: string;
	working: string;
	joy: string;
}

function HomeAllTrainer() {
	const navigate = useNavigate(); // useHistoryフックを使用

	const handleBack = () => {
		navigate(-1); // 前のページに戻る
	};

	const [selectedTrainer, setSelectedTrainer] = useState<Trainer | null>(null);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const trainers = [
		{
			name: "大沢 臣爾",
			subName: "おおさわおやびん",
			position: "スタッフ/キャリアコンサルタント",
			thumbImage: "images/osawa01.png",
			subImage: "images/osawa02.png",
			working: "不定期・火曜日",
			joy: "",
			comment:
				"キャリアコンサルタントとしてみなさんの卒業後に向けたサポートをさせていただきます！STUDIOにはほとんどいませんが、火曜日は比較的おりますし、就職・転職の相談がある時はスタッフを通してもしくはチャットでお声掛けください！",
		},
		{
			name: "寺越真知子",
			subName: "まちこさん",
			position: "スタッフ",
			thumbImage: "images/machiko.png",
			subImage: "images/machiko02.png",
			working: "平日・土日不定期（STUDIOにいないこともあります！）",
			joy: "",
			comment:
				"みなさんの学習と卒業後のサポートをさせていただきます！STUDIOではカウンターの中にいることが多いですが気軽に声をかけてね！自分の力で自分の未来を切り拓いていけるようにがんばりましょう！",
		},
		{
			name: "杉野舞",
			subName: "すぎまい",
			position: "スタッフ",
			thumbImage: "images/sugimai.png",
			subImage: "images/sugimai02.png",
			working: "平日・土日（ほとんどいます！）",
			joy: "映画を見ること（特に洋画が大好き）",
			comment:
				"運営スタッフのすぎまいです！これから皆様と一緒に頑張っていきたいと思いますので何卒、よろしくお願いいたします！",
		},
		{
			name: "関聖二",
			subName: "赤い人",
			position: "スタッフ",
			thumbImage: "images/seki.png",
			subImage: "images/seki02.png",
			working: "不定期（日本中飛び回っています！）",
			joy: "",
			comment:
				"STUDIOでも街中でも全身赤い人がいたら僕です！スタッフとしてみなさんの学習をサポートします！IT業界に長くいて、マーケティングやブランディングに多く携わってきた経験があるので、スキルだけではないデザイナーとしての考え方について何でも聞いてください！お酒はやめます！",
		},

		{
			name: "五十嵐渉",
			subName: "わたる先生（パンダ）",
			position: "スタッフ/トレーナー",
			thumbImage: "images/igarashi.png",
			subImage: "images/igarashi02.png",
			working: "火水金日曜",
			joy: "わたるハウス",
			comment:
				"わたるです！高校卒業後４年間のニートを経てフリーランスデザイナーとして10年活動してきました！クリエイターとしてのスキルや考え方ももちろんですが、自分との向き合い方や人生の考え方など、生きていく上でのお悩みも専門分野です！たくさんお話ししましょう！",
		},
		{
			name: "鈴木美佳",
			subName: "すずせんせー",
			position: "トレーナー",
			thumbImage: "images/suzu.png",
			subImage: "images/suzu02.png",
			working: "火木金曜",
			joy: "chromebook",
			comment:
				"トレーナーの鈴木です！すずせんせーって呼んでください！制作会社勤務からのフリーランス、そしてSTUDIO札幌のトレーナーとして経験を積んでおります！ふわっとゆるっと、時にばしっとみなさんの背中を押す担当です！たくさん話かけてね！",
		},
		{
			name: "市村洋隆",
			subName: "いちむらシェフ",
			position: "トレーナー",
			thumbImage: "images/ichimura.png",
			subImage: "images/ichimura02.png",
			working: "木土曜",
			joy: "料理、お菓子作り",
			comment:
				"シェフの市村です。旧デジハリの卒業生で、エンジニアや講師として20年近くの経験があります。業界の最新の情報やトレンドを皆さんに提供いたします。料理やお菓子作りが趣味なので、そちらもぜひ情報交換しましょ〜",
		},
		{
			name: "齋藤りり子",
			subName: "りりこさん",
			position: "トレーナー",
			thumbImage: "images/ririko.png",
			subImage: "images/ririko02.png",
			working: "平日日中・不定期",
			joy: "",
			comment:
				"トレーナーのりりこです！平日の夕方まで、カウンターの中まちこさんの隣にいます！私もSTUDIO札幌の卒業生で、子育てをしながらフリーランスとして仕事もしています！ママさんならではの悩みや工夫に関してたくさんアドバイスできますので、ぜひ声をかけてください！",
		},
		{
			name: "白戸智真",
			subName: "しらってぃ",
			position: "トレーナー",
			thumbImage: "images/shirato.png",
			subImage: "images/shirato03.png",
			working: "土曜",
			joy: "スプラトゥーン、寝ること",
			comment:
				"旅と水族館と石井竜也が好きです。スプラガチ勢です。STUDIOの仲間たちを演者として癒し系エンタメコントYouTubeチャンネルをやっています。登録よろしく！",
		},
		{
			name: "田中克幸",
			subName: "たなきゅん",
			position: "動画コーストレーナー",
			thumbImage: "images/tanaka.png",
			subImage: "images/tanaka02.png",
			working: "火曜・日曜オンライン",
			joy: "",
			comment:
				"紅白歌合戦にダンサーとして出演経験のあるローカルデザインプロデューサー田中です！東京から移住して厚真町に拠点を置いています！動画コースのトレーナーですが、クリエイティブなことなら何でもお話しできますので、お気軽のお声掛けください！お酒が好きです！",
		},
	];

	const handleTrainerClick = (trainer: Trainer) => {
		setSelectedTrainer(trainer);
		setIsModalOpen(true);
	};

	const closeModal = (event: React.MouseEvent<HTMLDivElement>) => {
		if (event.target === event.currentTarget) {
			setIsModalOpen(false);
			setSelectedTrainer(null);
		}
	};

	return (
		<main className={styles.inner}>
			<h1 className={styles.pageTitle}>スタッフ・トレーナー一覧</h1>
			<ul className={styles.alltrainerList}>
				{trainers.map((trainer) => (
					<li key={trainer.name} onClick={() => handleTrainerClick(trainer)}>
						<figure className={styles.img}>
							<img src={trainer.thumbImage} alt={trainer.name} />
						</figure>
						<p className={styles.name}>{trainer.name}</p>
						<p className={styles.position}>{trainer.position}</p>
						<p className={styles.working}>出勤：{trainer.working}</p>
					</li>
				))}
			</ul>

			{isModalOpen &&
				selectedTrainer && ( // selectedTrainerがnullでないことを確認
					<div
						className={`${styles.modal} ${isModalOpen ? styles.open : ""}`}
						onClick={closeModal}
					>
						<div className={styles.modalContent}>
							<span className={styles.close} onClick={closeModal}>
								&times;
							</span>
							<figure className={styles.images}>
								<div className={styles.img}>
									<img
										src={selectedTrainer.thumbImage}
										alt={selectedTrainer.name}
									/>
								</div>
								<div className={styles.img}>
									<img
										src={selectedTrainer.subImage}
										alt={selectedTrainer.name}
									/>
								</div>
							</figure>
							<div className={styles.info}>
								<p className={styles.name}>
									{selectedTrainer.name}
									<span className={styles.sub}>{selectedTrainer.subName}</span>
								</p>
								<p className={styles.position}>{selectedTrainer.position}</p>
								<p className={styles.working}>
									出勤：{selectedTrainer.working}
								</p>
							</div>
							{selectedTrainer.joy && ( // joyが空でない場合のみ表示
								<p className={styles.joy}>趣味：{selectedTrainer.joy}</p>
							)}
							<p className={styles.comment}>{selectedTrainer.comment}</p>
						</div>
					</div>
				)}
			<button onClick={handleBack} className={styles.goBack}>
				戻る
			</button>
		</main>
	);
}

export default HomeAllTrainer;
